/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Link, VFlow } from 'bold-ui'
import { Box } from 'components/Box'
import { LoadingIndicator } from 'components/loading'
import { useHistoricoRegulacaoEvolucaoQuery } from 'graphql/hooks.generated'
import { useState } from 'react'

import { HistoricoRegulacaoEvolucaoItem } from './HistoricoRegulacaoEvolucaoItem'

type HistoricoRegulacaoEvolucaoProps = {
  id: ID
}

export const HistoricoRegulacaoEvolucao = (props: HistoricoRegulacaoEvolucaoProps) => {
  const { id } = props

  const [isExpanded, setIsExpanded] = useState(false)

  const {
    data: { evolucoesRegulacao },
    loading,
  } = useHistoricoRegulacaoEvolucaoQuery({
    variables: {
      id,
    },
  })

  const evolucoes = evolucoesRegulacao ?? []
  const hasEvolucoes = evolucoes?.length > 0
  const isExpandable = evolucoes?.length > 1

  const initialVisibleEvolucoes = hasEvolucoes ? [evolucoes[0]] : []
  const currentVisibleEvolucoes = isExpanded ? evolucoes : initialVisibleEvolucoes

  const toggleExpanded = () => setIsExpanded((prevValue) => !prevValue)

  return (
    (loading || hasEvolucoes) && (
      <Box style={styles.box}>
        {loading ? (
          <LoadingIndicator />
        ) : (
          <VFlow vSpacing={0.5}>
            {currentVisibleEvolucoes.map((evolucao, index) => {
              const isPrimeiraEvolucao = evolucao.id === evolucoes[evolucoes.length - 1].id
              return (
                <HistoricoRegulacaoEvolucaoItem
                  key={evolucao.id}
                  item={evolucao}
                  showConnector={isExpanded && !isPrimeiraEvolucao}
                  showPrioridade={isPrimeiraEvolucao || evolucao.prioridade !== evolucoes[index + 1].prioridade}
                />
              )
            })}
            {isExpandable && (
              <Link onClick={toggleExpanded}>{isExpanded ? 'Ocultar status anteriores' : 'Ver status anteriores'}</Link>
            )}
          </VFlow>
        )}
      </Box>
    )
  )
}

const styles = {
  box: css`
    padding: 1rem;
    margin: 2rem 0;
  `,
}
